import { render, staticRenderFns } from "./LoteProdutoModal.vue?vue&type=template&id=96ed43c8"
import script from "./LoteProdutoModal.vue?vue&type=script&lang=js"
export * from "./LoteProdutoModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports